import React, { TableRow, TableCell, Collapse } from '@mui/material';
import { useState } from 'react';
import { Collapser, CustomerForm } from 'components';
import { CustomerRowProps } from './CustomerRowProps';

export const CustomerRow = ({ row }: CustomerRowProps) => {
	const [open, setOpen] = useState(false);
	return (
		<>
			<TableRow sx={{ '& > *': { borderBottom: 'unset' } }} onClick={() => setOpen(!open)}>
				<TableCell>
					<Collapser isAdd={false} open={open} />
				</TableCell>
				<TableCell>{row.email}</TableCell>
				<TableCell>{row.firstName}</TableCell>
				<TableCell>{row.lastName}</TableCell>
				<TableCell>{row.phoneNumber}</TableCell>
				<TableCell>{row.addressLine}</TableCell>
				<TableCell>{row.zipCode}</TableCell>
				<TableCell>{row.city}</TableCell>
				<TableCell>{row.country}</TableCell>
			</TableRow>
			<TableRow>
				<TableCell style={{ paddingBottom: 0, paddingTop: 0 }} colSpan={10}>
					<Collapse in={open} timeout='auto'>
						<CustomerForm row={row} />
					</Collapse>
				</TableCell>
			</TableRow>
		</>
	);
}
